import { render, staticRenderFns } from "./serviceNotice.vue?vue&type=template&id=1eab0060&scoped=true"
import script from "./serviceNotice.vue?vue&type=script&lang=js"
export * from "./serviceNotice.vue?vue&type=script&lang=js"
import style0 from "./serviceNotice.vue?vue&type=style&index=0&id=1eab0060&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eab0060",
  null
  
)

export default component.exports